module.exports = {
  pageTitle: 'Reset password',
  emailTitle: 'Please enter your email, a link to the reset password page will be sent to you.',
  formTitle: 'Please choose a new password',
  email: {
    label: 'Email',
  },
  ask: {
    successMessage:
      'An email with a link to reset your password was just sent to you. Please click on this link and follow the instruction to reset your password.',
    errorMessage: 'An unknown error just occured, please try again in a few minutes.',
  },
  password: {
    label: 'Password',
  },
  passwordConfirm: {
    label: 'Confirmation',
  },
  submit: {
    loading: 'Saving...',
    changePassword: 'Send',
  },
  successMessage:
    'Your new password has been set. You can now use it to login on <a href="/" target="_self">FishFriender.com</a>',
  unknownError: 'An unknown error has occured, please try again in a few minutes.',
}
